// src/components/quote/ScanAnimation.jsx

import React from "react";
import Lottie from "lottie-react";
import phoneScan from "../../assets/phone-scan.json";

export default function ScanAnimation({ size = 260 }) {
  return (
    <Lottie
      animationData={phoneScan}
      loop
      style={{ width: size, height: size }}
    />
  );
}
